import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Breadcrumbs({ step }) {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const breadcrumbs = [
    { path: ["/"], label: t("breadcrumbs.myClub") },
    { path: ["/plans"], label: t("breadcrumbs.plans") },
    { path: ["/user"], label: t("breadcrumbs.user") },
    { path: ["/contract", "/sepa"], label: t("breadcrumbs.contract") },
    { path: ["/card"], label: t("breadcrumbs.payment") },
  ];

  const spannishBreadcrumbs = [
    { path: ["/"], label: t("breadcrumbs.myClub") },
    { path: ["/plans"], label: t("breadcrumbs.plans") },
    { path: ["/user"], label: t("breadcrumbs.user") },
    { path: ["/card"], label: t("breadcrumbs.payment") },
    { path: ["/middle-confirmation"], label: t("breadcrumbs.confirmation") },
    { path: ["/contract", "/sepa"], label: t("breadcrumbs.contract") },
  ];

  const mapBreadscrumbs = i18n.language === "es" ? spannishBreadcrumbs : breadcrumbs;
  const currentPathIndex = mapBreadscrumbs.findIndex((breadcrumb) => breadcrumb.path.includes(location.pathname));

  return (
    <nav>
      <ul className="flex flex-nowrap flex-row justify-around w-full md:justify-center md:gap-12 lg:gap-16 xl:gap-20 mb-8 mt-10">
        {mapBreadscrumbs.map((breadcrumb, index) => (
          <li
            key={index}
            className={`flex flex-row text-base font-semibold justify-around items-center text-oaForegroundText`}
          >
            {index < currentPathIndex ? (
              <Link
                to={breadcrumb.path[0]}
                className="relative flex justify-center items-center flex-col gap-1 hover:text-oaRed transition-all duration-300"
              >
                <div className="text-xl font-semibold md:text-4xl md:font-bold">{index + 1}</div>
                <div
                  className={`w-12 md:w-20 h-[3px] md:h-[5px] ${
                    (step && step === breadcrumb.label) || breadcrumb.path.includes(location.pathname)
                      ? "bg-oaRed"
                      : "bg-oaForegroundText"
                  }`}
                ></div>
                <p
                  className={`absolute top-11 md:top-14 text-sm md:text-xl font-extrabold text-nowrap ${
                    (step && step === breadcrumb.label) || breadcrumb.path.includes(location.pathname)
                      ? "block"
                      : "hidden"
                  }`}
                >
                  {breadcrumb.label.toUpperCase()}
                </p>
              </Link>
            ) : (
              <div
                className={`relative flex justify-center items-center flex-col gap-1 ${
                  index === currentPathIndex ? "animate-fade-in" : ""
                }`}
              >
                <div className="text-xl font-semibold md:text-4xl md:font-bold">{index + 1}</div>
                <div
                  className={`w-12 md:w-20 h-[3px] md:h-[5px] ${
                    (step && step === breadcrumb.label) || breadcrumb.path.includes(location.pathname)
                      ? "bg-oaRed"
                      : "bg-oaForegroundText"
                  }`}
                ></div>
                <p
                  className={`absolute top-11 md:top-14 text-sm md:text-xl font-extrabold uppercase text-nowrap ${
                    (step && step === breadcrumb.label) || breadcrumb.path.includes(location.pathname)
                      ? "block"
                      : "hidden"
                  }`}
                >
                  {breadcrumb.label}
                </p>
              </div>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
